var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.789 71.121h-6.703a7.39 7.39 0 01-2.016-.285c-1.289-.406-2.309-1.332-3.059-2.777-.68-1.316-1.02-2.848-1.02-4.598 0-1.687.301-3.18.91-4.473.664-1.441 1.613-2.41 2.84-2.937a7.504 7.504 0 012.93-.605h6.074v3h-6.312c-1.027 0-1.773.578-2.234 1.723-.363.898-.543 2.074-.543 3.52 0 1.227.23 2.262.695 3.109.535 1.004 1.285 1.508 2.254 1.508l6.184-.023v2.84m11.164.07H61.66c-1.289 0-2.41-.566-3.363-1.703-.941-1.148-1.41-2.473-1.41-3.961 0-1.629.512-3.035 1.539-4.211 1.043-1.199 2.199-1.793 3.473-1.793h5.031v2.395h-3.687c-.461 0-.859.043-1.191.137-.32.074-.617.23-.891.469-.508.449-.758 1.051-.758 1.813h6.504v2.422h-6.484c0 .355.035.668.109.914.086.242.254.492.5.742.246.238.535.402.867.492a5.85 5.85 0 001.258.113h3.797v2.172m12.367-.07h-3.016v-7.637a1.02 1.02 0 00-.129-.512 1.72 1.72 0 00-.371-.473 1.482 1.482 0 00-.996-.379H71.86v9h-3.016v-11.6h5.77c1.027 0 1.773.059 2.234.18.723.18 1.301.57 1.734 1.188a4.07 4.07 0 01.738 2.352v7.879m8.66-9.18h-2.93v5.266c0 .473.16.871.477 1.184.363.313.84.473 1.434.473h.891v2.258h-2.801a2.82 2.82 0 01-2.145-.941 2.625 2.625 0 01-.676-1.227 7.288 7.288 0 01-.152-1.59v-5.422h-1.906v-2.418h1.906v-4.078h2.973v4.078h2.93v2.418m17.699 1.324c0 3.043-.816 5.219-2.449 6.539-1.332 1.059-3.27 1.59-5.813 1.59-2.82 0-4.902-.609-6.25-1.84-1.473-1.34-2.211-3.5-2.211-6.469 0-2.434.656-4.332 1.973-5.687 1.434-1.484 3.574-2.223 6.422-2.223 3.137 0 5.352.707 6.637 2.133 1.129 1.25 1.691 3.238 1.691 5.957m-3.859-.09c0-1.539-.355-2.766-1.062-3.676-.797-1.02-1.977-1.523-3.535-1.523-1.535 0-2.691.543-3.473 1.637-.648.91-.977 2.098-.977 3.563 0 1.688.262 2.93.781 3.734.723 1.125 2.063 1.68 4.016 1.68 1.648 0 2.805-.539 3.469-1.633.52-.852.781-2.109.781-3.781m21.223 3.09c0 1.367-.441 2.527-1.324 3.473s-2 1.406-3.359 1.406l-10.738-.023v-2.816h8.852c.59 0 1.09-.141 1.496-.43.461-.328.691-.773.691-1.34 0-1.332-.91-1.996-2.73-1.996h-4.469c-1.289 0-2.414-.406-3.383-1.227-.969-.828-1.453-1.871-1.453-3.145 0-1.398.469-2.539 1.41-3.402.953-.883 2.203-1.32 3.75-1.32h10.262v2.691H113c-.406 0-.816.176-1.234.535-.406.344-.609.75-.609 1.234a1.81 1.81 0 00.586 1.363c.406.363.891.535 1.453.535h4.926c1.531 0 2.73.414 3.598 1.234.883.805 1.324 1.883 1.324 3.227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 52.188h10.262v10.125H10.133zm0 0",
    fill: "#9ccc28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.766 51.827v10.849h10.995V51.827zm.733.723h9.529v9.402h-9.529z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.594 52.188H32.86v10.125H22.594zm0 0",
    fill: "#912178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.227 51.827v10.849h10.999V51.827zm.733.723h9.533v9.402H22.96z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.594 64.481H32.86v10.125H22.594zm0 0",
    fill: "#eea623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.227 64.12v10.848h10.999V64.12zm.733.723h9.533v9.402H22.96z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 64.481h10.262v10.125H10.133zm0 0",
    fill: "#232375"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.883 62.203l1.199 1.176-1.199 1.176h-8.449v3.922l-5.152-5.098 5.152-5.012v3.836zm0 0",
    fill: "#912178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.707 60.82L21.516 62l-1.195-1.18v-8.336h-3.977l5.172-5.078 5.078 5.078h-3.887zm0 0",
    fill: "#eea623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.109 64.594l-1.199-1.18 1.199-1.176h8.445v-3.922l5.152 5.098-5.152 5.016v-3.836zm0 0",
    fill: "#232375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.285 65.973l1.191-1.18 1.195 1.18v8.336h3.973l-5.168 5.078-5.082-5.078h3.891zm0 0",
    fill: "#9ccc28"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.766 64.12v10.848h10.995V64.12zm.733.723h9.529v9.402h-9.529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.907 63.399l.259.256 7.517 7.416 7.776-7.672-7.776-7.671zm1.037 0l6.739-6.649 6.739 6.649-6.739 6.649zm7.776-8.695l.259.256 7.517 7.416 7.776-7.672-7.776-7.672zm1.037 0l6.74-6.649 6.739 6.649-6.739 6.649zm15.552 1.023l-7.776 7.667.259.256 7.517 7.42 7.776-7.676zm0 1.023l6.74 6.645-6.739 6.652-6.74-6.653zM13.72 72.09l.259.256 7.517 7.416 7.776-7.672-7.776-7.668zm1.037 0l6.739-6.645 6.74 6.645-6.74 6.649z"
  })));
};